import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import { titleCase } from '../../../../utils/views/pages/Dynamics'

const InstallationTypeInformation = (props) => {
    const installationType = props.installationType
    const formDisabled = props.formDisabled
    const setInstallationType = props.setInstallationType
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        installationType[e.target.name] = e.target.value
        setInstallationType(installationType)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Installation Type information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Name
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={installationType?.name}
                                id="input-name"
                                name="name"
                                placeholder="Installation Type Name"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-reinstall"
                            >
                                Reinstallations
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={installationType?.reinstall}
                                id="input-reinstall"
                                name="reinstall"
                                placeholder="Installation Type Reinstallations"
                                type="number"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-period"
                            >
                                Period (Days)
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={installationType?.period}
                                id="input-period"
                                name="period"
                                placeholder="Installation Type Reinstallation Period"
                                type="number"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>


                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default InstallationTypeInformation;